import InvoiceStatusBadge from './InvoiceStatusBadge';

export default InvoiceStatusBadge;
